module.exports = __webpack_public_path__ + "static/27(2)-be1a2af0421c48cdc446a359d2abd46b.jpg";